import { findKey } from 'lodash';
import {
  jobDetailsPageRegex,
  searchResultsPageRegex,
  homePageRegex,
  expiredJobPageRegex
} from 'src/modules/routes-regexp';

const pageNameRegexps = {
  'job-details': jobDetailsPageRegex,
  'search-results': searchResultsPageRegex,
  home: homePageRegex,
  'expired-job': expiredJobPageRegex
};

export default pathname =>
  findKey(pageNameRegexps, regex => regex.test(pathname)) || '';
